export default __webpack_public_path__ + "static/media/Marc Berman.144a5c8d.jpg";